// @flow

import React from 'react'
import type { Image as ImageType } from 'types/'
import Container from './Container'
import Box from './Box'
import Appear from './Appear'

type BoxesItem = {
  key: string,
  image: ImageType,
  title: string,
  text: string,
  url?: string,
  ctaURL: string,
  ctaText: string,
  color: string,
  textColor: string,
}

type Props = {
  items: Array<BoxesItem>
}

const Boxes = ({ items }: Props) => {
  return (
    <Appear>
      <Container className="grid grid-cols-1 gap-5 mb-16 md:grid-cols-2">
        {items.map(item => (
          <React.Fragment key={item.key}>
            <Box {...item} />
          </React.Fragment>
        ))}
      </Container>
    </Appear>
  )
}

export default Boxes
